"use client";
import SectionPage from "@/components/common/section-page";

import { useNavigate } from "react-router-dom";
import EspaceProTitleCard from "@/components/common/espace-pro-title-card";
import {PageEnConstruction} from "@/components/common/page-en-construction";

export default function Home() {
  const navigate = useNavigate();

  return (
          <div className={"flex flex-col gap-6 pb-6 mb-8"}>

              <EspaceProTitleCard title={"Contacts pros"}
                                  middleBreadcrumbs={[{title: "Promotion", link: "/espace-pro/promotion"}]}
                                  description={"Côte d’Ivoire Tourisme Partenaire de réussite de l’industrie touristique."} />

          {/* Nature & Biodiversité */}
          <SectionPage sectionType="lg">
              <PageEnConstruction />
          </SectionPage>

        </div>
  );
}
